import { useEffect, useRef } from "react";

//use effect that does not run on initial render
export default function useNoInitialRenderEffect(fn, deps) {
  const initialRender = useRef(true);
  useEffect(() => {
    if (!initialRender.current) {
      fn();
    } else {
      initialRender.current = false;
    }
  }, deps);
}
